import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5de23c03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "ceci-list" }

import { ref, watchEffect } from 'vue'
import { getCeci } from '@/api/common'
import { CeciConfig } from '@/types'
import { ERR_SUCCESS } from '@/api/config'
import CeciDetail from '@/components/ceci/detail.vue'
import Pagination from '@/components/common/Pagination.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CeciList',
  props: ['singleSelect', 'multipleSelect', 'ceci_id'],
  emits: ['change'],
  setup(__props, { emit: __emit }) {

const dataList = ref<CeciConfig[]>([])
const currentPage = ref<number>(1)
const pageSize = ref<number>(12)
const totalItems = ref<number>(0)
const currentCeciId = ref(0)

// eslint-disable-next-line no-undef
const emit = __emit

const props = __props

const handleChange = (newValue: CeciConfig) => {
  currentCeciId.value = newValue.id
  emit('change', newValue)
}

async function fetchData () {
  try {
    const { subject = null, period = null } = props.singleSelect || {}
    const { platform = [], edition = [], grade = [], term = [] } = props.multipleSelect || {}
    const params = {
      page: currentPage.value,
      pageSize: pageSize.value,
      platform: Array.isArray(platform) ? platform.join(',') : platform,
      grade: Array.isArray(grade) ? grade.join(',') : grade,
      edition: Array.isArray(edition) ? edition.join(',') : edition,
      term: Array.isArray(term) ? term.join(',') : term,
      period,
      subject,
      id: undefined
    }
    if (props.ceci_id > 0) {
      params.id = props.ceci_id
    }
    const { code, result: { items: data, total } } = await getCeci({
      params
    })
    if (code === ERR_SUCCESS) {
      data.forEach((item) => {
        const [platform, period, subject, edition, grade, term] = item.title.split('_')
        item.period = period
        item.subject = subject
        item.platform = platform
        item.edition = edition
        item.grade = grade
        item.term = term
        item.title = `${edition}-${subject}`
      })
      dataList.value = data
      totalItems.value = total
    }
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}

watchEffect(() => {
  fetchData()
})


return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_el_empty, {
          "image-size": 300,
          description: "暂无数据"
        })
      ], 512), [
        [_vShow, dataList.value.length===0]
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "ceci-item"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass({ 'active-ceci': currentCeciId.value === item.id })
            }, [
              _createVNode(CeciDetail, {
                data: item,
                onClick: ($event: any) => (handleChange(item))
              }, null, 8, ["data", "onClick"])
            ], 2)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(Pagination, {
      "current-page": currentPage.value,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
      "page-size": pageSize.value,
      "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
      "total-size": totalItems.value
    }, null, 8, ["current-page", "page-size", "total-size"])
  ], 64))
}
}

})